itsoftApp.createModule("scrollEffectsSettings", ["pageLoad", "scrollEffects"], function () {
    const module = this;

    const ScrollEffectSettings = function () {
        this.scrollEffect = itsoftApp.modules.scrollEffects.ScrollEffect;
        this.fadeInElems = document.querySelectorAll(".js-anim");
        this.elemsInvisible = document.querySelectorAll(".js-invisible");

        this.init();
    };

    //анимация fadeIn элементов
    ScrollEffectSettings.prototype.initAnimation = function () {
        const SETTINGS = this;
        Array.prototype.forEach.call(this.fadeInElems, function (el) {
            new SETTINGS.scrollEffect(el, "js-anim--show", "js-anim");
        });

        Array.prototype.forEach.call(this.elemsInvisible, function (el) {
            new SETTINGS.scrollEffect(el, "js-visible", "js-invisible");
        });
    };

    ScrollEffectSettings.prototype.init = function () {
        const SETTINGS = this;
        itsoftApp.modules.pageLoad.addEvent(SETTINGS.initAnimation.bind(SETTINGS));
    };

    new ScrollEffectSettings();
    
    module.callback = ScrollEffectSettings;
});
